import type { BrightHorizonsAction } from '@rover/rsdk/src/apiClient/latest/model/brightHorizonsAction';
import type { BrightHorizonsRedeemCreditsDetail } from '@rover/rsdk/src/apiClient/latest/model/brightHorizonsRedeemCreditsDetail';
import { LinkActionActionType } from '@rover/rsdk/src/apiClient/latest/model/linkActionActionType';
import type { LinkActionBh } from '@rover/rsdk/src/apiClient/latest/model/linkActionBh';

export const isLinkAction = (action?: BrightHorizonsAction): action is LinkActionBh => {
  return action?.actionType === LinkActionActionType.link;
};

export const isBrightHorizonsRedeemCreditsResponseData = (
  data: unknown
): data is BrightHorizonsRedeemCreditsDetail => {
  return ['message', 'severity', 'event'].every((item) => !!data?.[item]);
};

/**
 * HOF utility function that rejects a promise after `timeoutMs` has ellapsed.
 */
export const withTimeout = <T>(
  promise: Promise<T>,
  timeoutError: Error,
  timeoutMs: number = 10000
): Promise<T> => {
  let timoutId: ReturnType<typeof setTimeout>;

  // eslint-disable-next-line promise/param-names
  const timeoutPromise: Promise<T> = new Promise((_, reject) => {
    timoutId = setTimeout(() => {
      reject(timeoutError);
    }, timeoutMs);
  });

  return Promise.race<T>([promise, timeoutPromise]).finally(() => clearTimeout(timoutId));
};
